import script from "./VolunteerSummaryChart.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerSummaryChart.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerSummaryChart.vue?vue&type=style&index=0&id=89222512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89222512"]])

export default __exports__